<!-- @format -->

<div class="skeleton-attribute-container">
	<div class="skeleton-attribute-section hmf-p-s">
		<div class="attribute-box">
			<div class="attribute-name-placeholder hmf-mb-xxs"></div>
			@for (item of [0, 0]; track trackbyFn($index)) {
				<div
					class="attribute-value-placeholder skeleton-grey-loading-animation hmf-round-radius hmf-mb-xxxs"></div>
			}
		</div>
	</div>

	<div class="skeleton-attribute-section hmf-p-s">
		<div class="attribute-box">
			<div
				class="attribute-name-placeholder skeleton-grey-loading-animation hmf-mb-xxs"></div>
			<div class="square-attributes hmf-display-flex hmf-flex-wrap">
				@for (item of [0, 0]; track trackbyFn($index)) {
					<div class="attribute-square-placeholder skeleton-grey-loading-animation"></div>
				}
			</div>
		</div>
	</div>
</div>
